import { ActionIcon, createStyles, Menu } from '@mantine/core';
import { Icon } from '@repo/foundations';
import type { IInboxActionMenuProps } from '../../types';
import { InboxListHeaderActions } from './InboxListHeaderActions';

const useStyles = createStyles((theme) => ({
	dropdown: {
		minHeight: 'fit-content',
	},
	actionIcon: {
		'&[data-opened]': {
			backgroundColor: theme.other.getColor('fill/secondary/hover'),
			color: theme.other.getColor('icon/secondary/hover'),
		},
	},
}));

export function ActionMenu({
	selected,
	hidden,
	opened,
	setOpened,
	handleDeleteAll,
	handleDeleteAllRead,
	handleMarkAllAsRead,
	handleDelete,
	handleMarkAsRead,
	navigate,
	user,
	workspace,
	notifications,
	markAsRead,
	restoreAllNotifications,
}: IInboxActionMenuProps) {
	const { classes } = useStyles();

	if (hidden) {
		return null;
	}

	return (
		<Menu
			classNames={{ dropdown: classes.dropdown }}
			width={256}
			position="bottom-start"
			withinPortal
			opened={opened}
			onOpen={() => setOpened(true)}
			onClose={() => setOpened(false)}
		>
			<Menu.Target>
				<ActionIcon
					size="sm"
					p={4}
					className={classes.actionIcon}
					data-opened={opened || undefined}
				>
					<Icon name="dots" color="icon/primary/default" />
				</ActionIcon>
			</Menu.Target>
			<Menu.Dropdown>
				<InboxListHeaderActions
					selected={selected}
					handleDeleteAll={handleDeleteAll}
					handleDeleteAllRead={handleDeleteAllRead}
					handleMarkAllAsRead={handleMarkAllAsRead}
					handleDelete={handleDelete}
					handleMarkAsRead={handleMarkAsRead}
					navigate={navigate}
					user={user}
					workspace={workspace}
					notifications={notifications}
					markAsRead={markAsRead}
					restoreAllNotifications={restoreAllNotifications}
				/>
			</Menu.Dropdown>
		</Menu>
	);
}
